export const stateName = 'profile';
export let PromoAfterItemUpload;

(function (PromoAfterItemUpload) {
  PromoAfterItemUpload["Empty"] = "empty";
  PromoAfterItemUpload["ListAnotherItem"] = "list_another_item";
  PromoAfterItemUpload["PushUpValueProposition"] = "push_up_value_proposition";
  PromoAfterItemUpload["PushUpCheckout"] = "push_up_checkout";
  PromoAfterItemUpload["ItemUploadFeedback"] = "item_upload_feedback";
  PromoAfterItemUpload["SellerOfflineVerification"] = "seller_offline_verification";
})(PromoAfterItemUpload || (PromoAfterItemUpload = {}));